import { render, staticRenderFns } from "./resultdisc.vue?vue&type=template&id=25fb010f&"
import script from "./resultdisc.vue?vue&type=script&lang=js&"
export * from "./resultdisc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports